import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";

import App from './App'
import About from './About'
import { PageTitle } from "./styles";
import TadpoleLogo from "./image-4.svg";
import lauriumLabsLogo from "./lauriumLabsLogo.png";
import { Typography } from "@material-ui/core";


export default function RouterComponent() {
    return (
        <Router>

            <div className="App" >
                <div style={{
                    display: "flex",
                    flexDirection: 'row',
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    alignItems: 'center',
                    marginLeft: 10,
                    marginRight: 10
                }}>
                    <Link to="/">
                        <div style={{ display: "flex", flexDirection: "row", alignItems: 'center' }}>
                            <PageTitle>TADPOLE</PageTitle>
                            <img
                                src={TadpoleLogo}
                                alt="tadpole"
                                style={{ height: 80, marginLeft: 20 }}
                            />
                        </div>
                    </Link>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <Link to="/about" style={{ color: 'white', marginRight: 20 }}><u>About this site</u></Link>

                        <div
                            style={{
                                fontSize: 10,
                                color: "white",
                                display: "flex",
                                flexWrap: "wrap",
                            }}
                        >


                            <a href="https://www.lauriumlabs.com">
                                <Typography
                                    style={{
                                        fontSize: 10,
                                        color: "white",
                                    }}
                                >
                                    Created By
                                <img
                                        style={{
                                            height: 40,
                                            display: "flex",
                                            flexWrap: "wrap",
                                        }}
                                        src={lauriumLabsLogo}
                                        alt="Laurium Labs Logo"

                                    ></img>
                                </Typography>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <Switch>

                <Route path="/" exact>
                    <App />
                </Route>
                <Route path="/about">
                    <About />
                </Route>

            </Switch>

        </Router >
    );
}